import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { CreditUserProfileUpdate, CreditUserStatusState } from "./credit-user";

export const useGetCreditUser = () => {
  return useSelector<AppStore, CreditUserProfileUpdate | undefined>(
    (store) => store.creditUserState
  );
};

export const useCreditUserStatus = () => {
  return useSelector<AppStore, CreditUserStatusState | undefined>(
    (store) => store.creditUserStatusState
  );
};
